import { AloftPrice, MLSListing } from '@aloft/toolkit-shared';

import { MLSDataColumn } from './MLSDataColumn.tsx';
import { MLSDataInfoSection } from './MLSDataInfoSection.tsx';
import { MLSDataValueWithLabel } from './MLSDataValueWithLabel.tsx';

export const MLSTaxInfo = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="Tax">
    <MLSDataColumn>
      {/* <MlsDataValueWithLabel value={details.tax_apn} label="APN" /> */}
      <MLSDataValueWithLabel
        value={listingData.TaxYear}
        label="Tax Year"
        options={{ noCommaInNumber: true }}
      />
    </MLSDataColumn>
    <MLSDataColumn>
      <MLSDataValueWithLabel
        value={
          listingData.TaxAnnualAmount
            ? AloftPrice.fromNumericPrice(listingData.TaxAnnualAmount ?? 0).toString(true)
            : undefined
        }
        label="Annual Tax"
      />
    </MLSDataColumn>
  </MLSDataInfoSection>
);
